var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-menu"},[_c('div',{staticClass:"row"},_vm._l((_vm.links),function(link){return _c('div',{key:link.text,staticClass:"col-12 col-md-12"},[_c('router-link',{staticClass:"nav-item",attrs:{"to":link.route}},[_c('a',{staticClass:"btn btn-link mx-auto"},[_c('i',{class:link.icon}),_vm._v(" "+_vm._s(link.text))])])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }